import { getUrlWithQueryParams } from '~/js/helpers/url-helper'
const ID_ZETA_REVIEW = 'ZVList'
const ID_ZETA_REVIEW_COUNT = 'zv-n-reviews'

const CLASS_NAME_LINK_TO_REVIEW = 't-product__link-to-review'

const getReviewCount = () => {
  const elementReviewCount = document.getElementById(ID_ZETA_REVIEW_COUNT)
  if (!elementReviewCount) return

  // elementReviewCount.innerText の例
  // \n11件のレビューがヒットしました。全てのレビューを表示
  const match = elementReviewCount.innerText.match(/\d+/)
  if (!match) return

  return Number(match[0])
}

document.addEventListener('zvrendercomplete', () => {
  const elementZetaReview = document.getElementById(ID_ZETA_REVIEW)
  if (!elementZetaReview) return
  if (elementZetaReview.dataset.isList === 'true') return

  const elementPagination = elementZetaReview.querySelector('.zv-pagination')
  if (elementPagination) elementPagination.remove()

  if (
    elementZetaReview.getElementsByClassName(CLASS_NAME_LINK_TO_REVIEW).length
  )
    return

  const elementsReview = elementZetaReview.getElementsByClassName(
    'zv-top-customer-review'
  )
  if (!elementsReview.length) return

  const count = getReviewCount()
  let innerText = 'すべてのレビューを見る'
  if (count) innerText += `（${count}件）`
  const elementA = document.createElement('a')
  const href = getUrlWithQueryParams({ view: 'review' })
  elementA.innerText = innerText
  elementA.setAttribute('href', href)
  elementA.classList.add(CLASS_NAME_LINK_TO_REVIEW)
  elementZetaReview.appendChild(elementA)
})
